import { StyleProps } from "../styles"

export const marginRight = (props: StyleProps) => ({
  marginRight: props.theme.spacing(7),
})

export const marginLeft = (props: StyleProps) => ({
  marginLeft: props.theme.spacing(8),
})

export const text = (props: StyleProps) => ({
  fontSize: props.theme.fontSize.caption,
})

export const makeIconButtonStyle = (props: StyleProps) => ({
  borderRadius: props.theme.borderRadius.round,
  height: 32,
  marginLeft: props.theme.spacing(2),
  padding: 0,
  width: 32,
})
